/* eslint-disable no-console */
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import {unitType, unitTypes} from '../interface/unitChange';

const changeUnit = (state: unitType): string => {
  return getUnits(state, useCompanyStore.getState().preUnits);
};

export const getUnits = (state: unitType, unitPrefered: any): any => {
  return state === unitTypes.WEIGHT
    ? unitPrefered.weight
    : state === unitTypes.ELECTRICITY
      ? unitPrefered.electricity
      : state === unitTypes.CURRENCY
        ? unitPrefered.currency
        : state === unitTypes.VOLUME
          ? unitPrefered.volume.liquid
          : state === unitTypes.VOLUME_LIQUID
            ? unitPrefered.volume.liquid
            : state === unitTypes.VOLUME_GAS
              ? unitPrefered.volume.gas
              : state === unitTypes.NA
                ? 'NA'
                : '';
};
export default changeUnit;
